// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cover-image--preview[data-v-77fab275]{position:relative;cursor:pointer}.cover-image--preview img[data-v-77fab275]{width:100%;height:auto}.play-button-overlay[data-v-77fab275]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);font-size:4em;color:#fff;text-shadow:0 0 10px rgba(0,0,0,.7)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
